function popupShow(button, popup) {
  button.addEventListener('click', function () {
    popup.classList.add('active');
    document.body.style.overflow = 'hidden';
  });
}

function popupSelect(options, input, button, popup) {
  options.forEach((option) => {
    option.addEventListener('click', function () {
      const selectedValue = this.textContent.trim();

      input.value = this.value;
      button.textContent = selectedValue;
      popup.classList.remove('active');
      document.body.style.overflow = '';
    });
  });
}

function setError(el, state) {
  if (state) {
    el.classList.add('error');
  } else {
    el.classList.remove('error');
  }
}

function validateEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

function showPopup(type, fields) {
  const errorPopup = document.querySelector('.error-popup');
  const errorEmpty = errorPopup.querySelector('.error-popup-content-text.empty');
  const errorUnvalid = errorPopup.querySelector('.error-popup-content-text.unvalid');

  errorPopup.classList.add('active');
  errorEmpty.style.display = 'none';
  errorUnvalid.style.display = 'none';

  if (type === 'empty') {
    errorEmpty.style.display = 'block';
    errorEmpty.textContent = errorEmpty.textContent.replace(/"(.*?)"/, `"${fields.join(', ')}"`);
  }
  if (type === 'unvalid') {
    errorUnvalid.style.display = 'block';
    errorUnvalid.textContent = errorUnvalid.textContent.replace(/"(.*?)"/, `"${fields.join(', ')}"`);
  }

  setTimeout(() => {
    errorPopup.classList.remove('active');
  }, 3000);
}

function validateForm(nameInput, emailInput, reasonInput, professionInput, reasonButton, professionButton) {
  let isValid = true;
  let hasEmpty = false;
  let hasInvalid = false;

  let emptyFields = [];

  function deleteFromEmpty(value) {
    const index = emptyFields.indexOf(value);
    if (index > -1) {
      emptyFields.splice(index, 1);
    }
  }

  if (nameInput.value.length < 1) {
    setError(nameInput, true);
    hasEmpty = true;
    emptyFields.push('name');
  } else {
    deleteFromEmpty('name');
    setError(nameInput, false);
  }

  if (emailInput.value.length == 0) {
    setError(emailInput, true);
    hasEmpty = true;
    emptyFields.push('email');
  } else if (!validateEmail(emailInput.value.trim())) {
    setError(emailInput, true);
    isValid = false;
  } else {
    deleteFromEmpty('email');
    setError(emailInput, false);
  }

  if (!reasonInput.value.trim()) {
    setError(reasonButton, true);
    hasEmpty = true;
    emptyFields.push('reason');
  } else {
    deleteFromEmpty('reason');
    setError(reasonButton, false);
  }

  if (!professionInput.value.trim()) {
    setError(professionButton, true);
    hasEmpty = true;
    emptyFields.push('profession');
  } else {
    deleteFromEmpty('profession');
    setError(professionButton, false);
  }

  if (!isValid || hasEmpty) {
    if (hasEmpty) showPopup('empty', emptyFields);
    else if (!isValid) showPopup('unvalid', ['email']);
  }

  return isValid && !hasEmpty;
}

async function sendDataToKlaviyo(name, email, reason, profession, message) {
  let language = 'EN';

  if (window.KL_LANGUAGE === 'fr') {
    language = 'FR';
  } else if (window.KL_LANGUAGE === 'de') {
    language = 'DE';
  }

  const payload = {
    $email: email || undefined,
    $first_name: name || undefined,
    Reason: reason || undefined,
    profession: profession || undefined,
    message: message || undefined,
    Language: language,
  };

  try {
    await klaviyo.identify(payload);
    await klaviyo.track('Research Contact', payload);
  } catch (e) {
    console.warn('Klaviyo identify/track error:', e);
  }
}

function toggleThankYou(formContainer, thankYouContainer) {
  if (!formContainer || !thankYouContainer) return;

  formContainer.classList.toggle('active');
  thankYouContainer.classList.toggle('active');
}

function resetForm(inputs) {
  inputs.forEach((input) => (input.value = ''));
}

function closePopupOnOutsideClick(popup, button) {
  popup.addEventListener('click', (event) => {
    if (!popup.classList.contains('active')) return;

    const isClickOnButton = button.contains(event.target);

    if (!isClickOnButton) {
      popup.classList.remove('active');
      document.body.style.overflow = '';
    }
  });
}

function setUpperLineText(el) {
  let value = el.textContent;

  if (!value) {
    value = el.getAttribute('placeholder') || '';
  }
  if (value) {
    const wrapper = el.closest('.research-contact-input-wrapper');
    const upperlineText = wrapper.querySelector('.research-contact-input-text-upperline');
    wrapper.classList.add('active');
    upperlineText.textContent = value;
    upperlineText.style.display = 'block';
  }
}

function callOnFirstInput(formWrapper) {
  formWrapper.querySelectorAll('input, button').forEach((el) => {
    let called = false;

    const handler = () => {
      if (!called) {
        setUpperLineText(el);
        called = true;
      }
    };

    el.addEventListener('input', handler, { once: true });
    el.addEventListener('click', handler, { once: true });
  });
}

document.addEventListener('DOMContentLoaded', () => {
  const formWrapper = document.querySelector('#research-contact-wrp');

  const professionButton = formWrapper.querySelector('.research-contact-input-button.profession');
  const reasonButton = formWrapper.querySelector('.research-contact-input-button.reason');
  const professionPopup = document.querySelector('.research-contact-selection-popup.profession');
  const reasonPopup = document.querySelector('.research-contact-selection-popup.reason');
  const professionOptions = professionPopup.querySelectorAll('.research-contact-selection-popup-option');
  const reasonOptions = reasonPopup.querySelectorAll('.research-contact-selection-popup-option');
  const professionInput = formWrapper.querySelector('input[name="profession"]');
  const reasonInput = formWrapper.querySelector('input[name="reason"]');

  const sendButton = formWrapper.querySelector('.research-contact-button');
  const nameInput = formWrapper.querySelector('.research-contact-input.name');
  const emailInput = formWrapper.querySelector('.research-contact-input.email');
  const messageInput = formWrapper.querySelector('.research-contact-textarea');

  const formContainer = formWrapper.querySelector('.research-contact-input-container');
  const thankYouContainer = formWrapper.querySelector('.research-contact-thank-you-container');
  const resetButton = formWrapper.querySelector('.research-contact-thank-you-link');

  closePopupOnOutsideClick(professionPopup, professionButton);
  popupShow(professionButton, professionPopup);

  closePopupOnOutsideClick(reasonPopup, reasonButton);
  popupShow(reasonButton, reasonPopup);

  popupSelect(professionOptions, professionInput, professionButton, professionPopup);
  popupSelect(reasonOptions, reasonInput, reasonButton, reasonPopup);

  sendButton.addEventListener('click', async (e) => {
    const valid = validateForm(nameInput, emailInput, reasonInput, professionInput, reasonButton, professionButton);

    if (valid) {
      await sendDataToKlaviyo(nameInput.value, emailInput.value, reasonInput.value, professionInput.value, messageInput.value);

      toggleThankYou(formContainer, thankYouContainer);

      resetForm([nameInput, emailInput, professionInput, reasonInput, messageInput]);
    }
  });

  callOnFirstInput(formWrapper);

  resetButton.addEventListener('click', () => {
    toggleThankYou(formContainer, thankYouContainer);
    resetForm([nameInput, emailInput, professionInput, reasonInput, messageInput]);
  });

  [nameInput, emailInput, messageInput].forEach((input) => {
    input.addEventListener('input', () => input.classList.remove('error'));
  });
});
